import braidsImage from '../assets/services/service-braids.webp';
import consultationImage from '../assets/services/service-consultation.webp';
import cornrowsImage from '../assets/services/service-cornrows.webp';
import dreadlocksImage from '../assets/services/service-dreadlocks.webp';
import twistsImage from '../assets/services/service-twists.webp';

export const services = [
  {
    id: 'braids',
    icon: '👑',
    image: braidsImage,
    de: {
      title: 'Braids',
      priceFrom: '60 €',
      duration: '3–5 Stunden',
      description: 'Klassische Braids, sauber gearbeitet und individuell abgestimmt.',
      imageAlt: 'Nahaufnahme sauber geflochtener Braids im warmen Studio',
    },
    en: {
      title: 'Braids',
      priceFrom: '€60',
      duration: '3–5 hours',
      description: 'Classic braids, clean work and individually matched to your style.',
      imageAlt: 'Close-up of neat braids in a warm studio',
    },
  },
  {
    id: 'cornrows',
    icon: '〰️',
    image: cornrowsImage,
    de: {
      title: 'Cornrows',
      priceFrom: '45 €',
      duration: '1,5–3 Stunden',
      description: 'Präzise geflochtene Cornrows für moderne und traditionelle Looks.',
      imageAlt: 'Nahaufnahme präziser Cornrows mit klaren Linien',
    },
    en: {
      title: 'Cornrows',
      priceFrom: '€45',
      duration: '1.5–3 hours',
      description: 'Precise cornrows for modern and traditional looks.',
      imageAlt: 'Close-up of precise cornrows with clean parting',
    },
  },
  {
    id: 'dreadlocks',
    icon: '🌀',
    image: dreadlocksImage,
    de: {
      title: 'Dreadlocks',
      priceFrom: '70 €',
      duration: '2–4 Stunden',
      description: 'Pflege, Nacharbeit und Beratung rund um Dreadlocks.',
      imageAlt: 'Nahaufnahme gepflegter Dreadlocks mit sauberer Nacharbeit',
    },
    en: {
      title: 'Dreadlocks',
      priceFrom: '€70',
      duration: '2–4 hours',
      description: 'Care, maintenance and consultation for dreadlocks.',
      imageAlt: 'Close-up of maintained dreadlocks with tidy retwist detail',
    },
  },
  {
    id: 'twists',
    icon: '✨',
    image: twistsImage,
    de: {
      title: 'Twists',
      priceFrom: '50 €',
      duration: '2–3 Stunden',
      description: 'Schöne Twists mit natürlichem Look und angenehmem Tragegefühl.',
      imageAlt: 'Nahaufnahme gepflegter Twists im Salon',
    },
    en: {
      title: 'Twists',
      priceFrom: '€50',
      duration: '2–3 hours',
      description: 'Beautiful twists with a natural look and comfortable feel.',
      imageAlt: 'Close-up of neat twists in a salon',
    },
  },
  {
    id: 'consultation',
    icon: '💬',
    image: consultationImage,
    de: {
      title: 'Beratung',
      priceFrom: '20 €',
      duration: '30 Minuten',
      description:
        'Persönliche Beratung für Style, Aufwand, Dauer und Pflege. Kommt danach ein Termin zustande, werden die 20 € gutgeschrieben.',
      imageAlt: 'Beratungstisch mit Style-Beispielen und Pflegeprodukten',
    },
    en: {
      title: 'Consultation',
      priceFrom: '€20',
      duration: '30 minutes',
      description:
        'Personal consultation for style, effort, duration and care. If you book an appointment afterwards, the €20 are credited.',
      imageAlt: 'Consultation table with style examples and care products',
    },
  },
];

export function getServiceText(service, language) {
  return service[language] || service.de;
}
